import * as React from "react"
import { Box, Typography } from "@mui/material";
import {IconSeeker} from "@ui-seeker/core";
import { translateCountryName } from "@ui-seeker/utils"

import {RetailerBlock} from "@components";
import { useStockAssortmentDetailsShowNotListed } from "../@hooks";


export default function retailerColumn() {
	return [{
		name: 'date', label: 'date',
		options: {
			display: 'excluded',
			customBodyRowRender: v => translateCountryName(v)
		}
	}, {
		name: 'country', label: 'Market',
		options: {
			display: 'excluded',
			customBodyRowRender: v => translateCountryName(v)
		}
	}, {
		name: 'externalSeller', label: 'Is 3P?',
		options: {
			display: 'excluded',
			customBodyRowRender: value => value ? 'Yes' : 'No'
		}
	}, {
		name: "retailer", label: 'Retailer',
		options: {
			customBodyRowRender: (value, { country, siteURL, siteID, date }) => <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', gap: 2 }}>
				<RetailerBlock 
					retailer={value}
					country={country}
					date={date}
					siteURL={siteURL}
				/>
				 <ShowNotListedCell siteID={siteID} />
			</Box>
		}
	}]
}

const ShowNotListedCell = ({siteID}) => {
	const { handleClickShowNotListed } = useStockAssortmentDetailsShowNotListed(siteID)

    return <Box sx={{ display: 'flex', alignItems: 'flex-end'}} onClick={handleClickShowNotListed} data-tour-show-all >
        <IconSeeker icon={'file'} iconWeight={'light'} sx={{ mr: 0.5, margin: .5, color: 'primary.main'}}/>
		<Typography variant="caption" sx={{ display: 'block', color: "text.primary", mt: 1, mr: 0.5, cursor: 'pointer', "&:hover":{ textDecoration: 'underline'} }}>
            Show All Assortment
        </Typography>
    </Box>

}